import { useIdleCheck } from "./hooks/useIdleCheck/useIdleCheck";
import { IdleModal } from "./modal/IdleModal";

export const IdleChecker = () => {
  const { isIdleModalShown, continueSession } = useIdleCheck();

  return <IdleModal open={isIdleModalShown} continueSession={continueSession} />;
}
